import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/doc_labels`, {params: {...filter}})
  },

  create(doc_label){
    return Http.post(`/doc_labels`, {doc_label: {
      ...doc_label,
    }})
  },

  update(doc_label){
    return Http.put(`/doc_labels/${doc_label.id}`, {
      doc_label: {
        ...doc_label,
      },
    });
  },

  show(id) {
    return Http.get(`/doc_labels/${id}`);
  },

  showClientLastOrder(filter = {}) {
    return Http.get(`/doc_label_last_orders`, {params: {...filter}});
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
